
import * as THREE from 'three';import{OrbitControls}from'three/addons/controls/OrbitControls.js';import{GLTFLoader}from'three/addons/loaders/GLTFLoader.js';import{GLTFExporter}from'three/addons/exporters/GLTFExporter.js';
const SHOPIFY_VARIANTS=[{"module":"TS01","finish":"birch","pads":"square","sku":"HUX-BCMP-TS01-BIRCH-SQ-ERA","price":1266.0},{"module":"TS01","finish":"birch","pads":"rectangle","sku":"HUX-BCMP-TS01-BIRCH-RT-ERA","price":1266.0},{"module":"TS01","finish":"oak","pads":"square","sku":"HUX-BCMP-TS01-OAK-SQ-ERA","price":1266.0},{"module":"TS01","finish":"oak","pads":"rectangle","sku":"HUX-BCMP-TS01-OAK-RT-ERA","price":1266.0},{"module":"TS02","finish":"birch","pads":"square","sku":"HUX-BCMP-TS02-BIRCH-SQ-ERA","price":1488.0},{"module":"TS02","finish":"birch","pads":"rectangle","sku":"HUX-BCMP-TS02-BIRCH-RT-ERA","price":1488.0},{"module":"TS02","finish":"oak","pads":"square","sku":"HUX-BCMP-TS02-OAK-SQ-ERA","price":1488.0},{"module":"TS02","finish":"oak","pads":"rectangle","sku":"HUX-BCMP-TS02-OAK-RT-ERA","price":1488.0},{"module":"TS06","finish":"birch","pads":"square","sku":"HUX-BCMP-TS06-BIRCH-SQ-ERA","price":1716.0},{"module":"TS06","finish":"birch","pads":"rectangle","sku":"HUX-BCMP-TS06-BIRCH-RT-ERA","price":1716.0},{"module":"TS06","finish":"oak","pads":"square","sku":"HUX-BCMP-TS06-OAK-SQ-ERA","price":1716.0},{"module":"TS06","finish":"oak","pads":"rectangle","sku":"HUX-BCMP-TS06-OAK-RT-ERA","price":1716.0},{"module":"TS04","finish":"birch","pads":"square","sku":"HUX-BCMP-TS04-BIRCH-SQ-ERA","price":960.0},{"module":"TS04","finish":"birch","pads":"rectangle","sku":"HUX-BCMP-TS04-BIRCH-RT-ERA","price":960.0},{"module":"TS04","finish":"oak","pads":"square","sku":"HUX-BCMP-TS04-OAK-SQ-ERA","price":960.0},{"module":"TS04","finish":"oak","pads":"rectangle","sku":"HUX-BCMP-TS04-OAK-RT-ERA","price":960.0},{"module":"TS14","finish":"birch","pads":null,"sku":"HUX-BCMP-TS14-BIRCH","price":870.0},{"module":"TS14","finish":"oak","pads":null,"sku":"HUX-BCMP-TS14-OAK","price":870.0},{"module":"TS01_STORAGE","finish":"birch","pads":"square","sku":"HUX-BCMP-TS01_STG-BIRCH-SQ-ERA","price":1375.0},{"module":"TS01_STORAGE","finish":"birch","pads":"rectangle","sku":"HUX-BCMP-TS01_STG-BIRCH-RT-ERA","price":1375.0},{"module":"TS01_STORAGE","finish":"oak","pads":"square","sku":"HUX-BCMP-TS01_STG-OAK-SQ-ERA","price":1375.0},{"module":"TS01_STORAGE","finish":"oak","pads":"rectangle","sku":"HUX-BCMP-TS01_STG-OAK-RT-ERA","price":1375.0},{"module":"TS09","finish":"birch","pads":null,"sku":"HUX-BCMP-TS09-BIRCH","price":210.0},{"module":"TS09","finish":"oak","pads":null,"sku":"HUX-BCMP-TS09-OAK","price":210.0},{"module":"TS10","finish":"birch","pads":null,"sku":"HUX-BCMP-TS10-BIRCH","price":230.0},{"module":"TS10","finish":"oak","pads":null,"sku":"HUX-BCMP-TS10-OAK","price":230.0},{"module":"TS04_800","finish":"birch","pads":"square","sku":"HUX-BCMP-TS04_800-BIRCH-SQ-ERA","price":960.0},{"module":"TS04_800","finish":"birch","pads":"rectangle","sku":"HUX-BCMP-TS04_800-BIRCH-RT-ERA","price":960.0},{"module":"TS04_800","finish":"oak","pads":"square","sku":"HUX-BCMP-TS04_800-OAK-SQ-ERA","price":960.0},{"module":"TS04_800","finish":"oak","pads":"rectangle","sku":"HUX-BCMP-TS04_800-OAK-RT-ERA","price":960.0}];
const API_BASE=(location.hostname==='localhost'||location.hostname==='127.0.0.1')?'http://localhost:3000':'/apps/huxlo';
const SHOPIFY_API_URL=API_BASE+'/api/basecamp/variants';
const DESIGN_API_URL=API_BASE+'/api/basecamp/designs';
const CONFIGURATOR_ROOT=document.getElementById('huxlo-basecamp-configurator');
const IS_EMBEDDED=!!CONFIGURATOR_ROOT?.classList.contains('huxlo-embedded');
let pricingSource='fallback';
let liveVariantCount=0;
async function loadLiveShopifyPricing(){
  try{
    const response=await fetch(SHOPIFY_API_URL,{cache:'no-store'});
    if(!response.ok)throw new Error(`Pricing API ${response.status}`);
    const data=await response.json();
    if(!data.ok||!data.variants)throw new Error('Invalid pricing response');
    let matched=0;
    for(const mapped of SHOPIFY_VARIANTS){
      const live=data.variants[mapped.sku];
      if(!live)continue;
      const price=Number(live.price);
      if(!Number.isFinite(price))continue;
      mapped.price=price;
      mapped.variantId=live.variantId||null;
      mapped.productId=live.productId||null;
      matched++;
    }
    if(!matched)throw new Error('No mapped Basecamp SKUs returned');
    pricingSource='live';
    liveVariantCount=data.count||matched;
    if(typeof currentConfig!=='undefined'&&currentConfig)build(false);
    console.info(`Live Shopify pricing loaded: ${matched} configurator SKUs matched from ${liveVariantCount} Basecamp variants.`);
  }catch(error){
    pricingSource='fallback';
    console.warn('Live Shopify pricing unavailable; using embedded fallback prices.',error);
    if(typeof currentConfig!=='undefined'&&currentConfig)build(false);
  }
}

const host=document.getElementById('viewer'),status=document.getElementById('status');

// Minimal model-loading indicator. It only appears while a GLB is actually being fetched.
if(getComputedStyle(host).position==='static')host.style.position='relative';
const modelSpinner=document.createElement('div');
modelSpinner.setAttribute('aria-label','Loading 3D model');
modelSpinner.style.cssText='position:absolute;left:50%;top:50%;width:28px;height:28px;margin:-14px 0 0 -14px;border:2px solid rgba(20,20,20,.16);border-top-color:rgba(20,20,20,.72);border-radius:50%;z-index:20;pointer-events:none;display:none;animation:huxloModelSpin .75s linear infinite';
host.appendChild(modelSpinner);
const spinnerStyle=document.createElement('style');
spinnerStyle.textContent='@keyframes huxloModelSpin{to{transform:rotate(360deg)}}';
document.head.appendChild(spinnerStyle);
let activeModelLoads=0;
function beginModelLoad(){activeModelLoads++;modelSpinner.style.display='block'}
function endModelLoad(){activeModelLoads=Math.max(0,activeModelLoads-1);if(!activeModelLoads)modelSpinner.style.display='none'}

const scene=new THREE.Scene();scene.background=new THREE.Color(0xeeeeeb);
const camera=new THREE.PerspectiveCamera(35,1,.01,100);camera.position.set(5,3.5,5);
const renderer=new THREE.WebGLRenderer({antialias:true,preserveDrawingBuffer:true});renderer.setPixelRatio(Math.min(devicePixelRatio,2));renderer.outputColorSpace=THREE.SRGBColorSpace;renderer.toneMapping=THREE.ACESFilmicToneMapping;renderer.toneMappingExposure=1.05;host.appendChild(renderer.domElement);
const controls=new OrbitControls(camera,renderer.domElement);controls.enableDamping=true;controls.minPolarAngle=0.05;controls.maxPolarAngle=Math.PI/2;
scene.add(new THREE.HemisphereLight(0xffffff,0x777777,2));const key=new THREE.DirectionalLight(0xffffff,3);key.position.set(4,7,5);scene.add(key);const fill=new THREE.DirectionalLight(0xffffff,1);fill.position.set(-4,3,-3);scene.add(fill);scene.add(new THREE.GridHelper(12,24,0xc5c5c5,0xdadada));
function baseName(n){
  return (n||'').replace(/[._-]\d{3}(?:_\d+)?$/,'').toUpperCase();
}
function findGroups(root,name){
  const wanted=name.toUpperCase(), out=[];
  root.traverse(o=>{ if(baseName(o.name)===wanted) out.push(o); });
  return out;
}
function markPadMeshes(root) {
  function walk(o, inheritedStyle = null) {
    const n = (o.name || '').toUpperCase().replace(/[.\-]/g, '_');
    let style = inheritedStyle;
    if (n.startsWith('PADS_SQUARE')) style = 'square';
    if (n.startsWith('PADS_RECTANGLE')) style = 'rectangle';

    if (o.isMesh && style) {
      o.userData.huxloPadStyle = style;
    }
    o.children.forEach(child => walk(child, style));
  }
  walk(root);
}
function setPads(root, square) {
  const wanted = square ? 'square' : 'rectangle';
  let sq = 0, rect = 0;
  root.traverse(o => {
    if (!o.isMesh || !o.userData.huxloPadStyle) return;
    o.visible = o.userData.huxloPadStyle === wanted;
    if (o.userData.huxloPadStyle === 'square') sq++;
    if (o.userData.huxloPadStyle === 'rectangle') rect++;
  });
  console.log('Pad meshes tagged:', {square:sq, rectangle:rect, showing:wanted});
}
function cloneMaterialTree(root){
  root.traverse(o=>{
    if(!o.isMesh)return;
    if(Array.isArray(o.material)) o.material=o.material.map(m=>m.clone());
    else if(o.material) o.material=o.material.clone();
  });
}
function tintConfigurable(root,mode){
  let changed=0;
  root.traverse(o=>{
    if(!o.isMesh)return;
    const mats=Array.isArray(o.material)?o.material:[o.material];
    mats.filter(Boolean).forEach(m=>{
      // Material-name fallback makes this independent of Blender's Empty suffixes.
      if(baseName(m.name)!=='BIRCH') return;
      if(!m.userData.huxloOrigColor) m.userData.huxloOrigColor='#'+m.color.getHexString();
      if(mode==='birch') m.color.set(m.userData.huxloOrigColor);
      else m.color.set('#8b623d');
      if('roughness' in m) m.roughness=0.88;
      if('metalness' in m) m.metalness=0;
      m.needsUpdate=true;
      changed++;
    });
  });
  console.log('finish',root.name,mode,'birch materials changed',changed);
}
const ERA_COLOURS=[{"name":"Transition","code":"CSE30","hex":"#DCD3B7"},{"name":"Splitsecond","code":"CSE31","hex":"#C7A26A"},{"name":"Lifetime","code":"CSE03","hex":"#D6C35D"},{"name":"Occasion","code":"CSE32","hex":"#C8A621"},{"name":"Measure","code":"CSE27","hex":"#B66531"},{"name":"Sequence","code":"CSE25","hex":"#B58368"},{"name":"Span","code":"CSE05","hex":"#C95D32"},{"name":"Turn","code":"CSE26","hex":"#A85C46"},{"name":"Experience","code":"CSE29","hex":"#923D39"},{"name":"Extent","code":"CSE28","hex":"#6B2B31"},{"name":"Calendar","code":"CSE19","hex":"#CDA9A4"},{"name":"Date","code":"CSE24","hex":"#B9A09B"},{"name":"Cycle","code":"CSE06","hex":"#9C343C"},{"name":"Phase","code":"CSE17","hex":"#8D2451"},{"name":"Prime","code":"CSE09","hex":"#4E3A56"},{"name":"Allowance","code":"CSE38","hex":"#98B2C8"},{"name":"Chapter","code":"CSE08","hex":"#60769B"},{"name":"Perennial","code":"CSE12","hex":"#304C85"},{"name":"Range","code":"CSE42","hex":"#293B59"},{"name":"Maturity","code":"CSE40","hex":"#142D55"},{"name":"Notation","code":"CSE36","hex":"#8A9D72"},{"name":"Rest","code":"CSE37","hex":"#4F826C"},{"name":"Aeon","code":"CSE20","hex":"#8FAFA7"},{"name":"Everlasting","code":"CSE10","hex":"#248B9B"},{"name":"Stage","code":"CSE15","hex":"#18526B"},{"name":"Analogue","code":"CSE33","hex":"#A6A78E"},{"name":"Endurance","code":"CSE34","hex":"#838D64"},{"name":"Period","code":"CSE07","hex":"#9AC449"},{"name":"Futurist","code":"CSE01","hex":"#D4D0C1"},{"name":"Timelapse","code":"CSE16","hex":"#738E3F"},{"name":"Event","code":"CSE18","hex":"#4D9C62"},{"name":"Signature","code":"CSE35","hex":"#0F4C39"},{"name":"Occurrence","code":"CSE23","hex":"#9A817B"},{"name":"Prompt","code":"CSE45","hex":"#A5A497"},{"name":"Generation","code":"CSE02","hex":"#807C7A"},{"name":"History","code":"CSE21","hex":"#554B4A"},{"name":"Quota","code":"CSE41","hex":"#B7AB9F"},{"name":"Memo","code":"CSE46","hex":"#B5B5B0"},{"name":"Youth","code":"CSE39","hex":"#A7B4C1"},{"name":"Late","code":"CSE43","hex":"#526D78"},{"name":"Forecast","code":"CSE11","hex":"#767676"},{"name":"Present","code":"CSE13","hex":"#55565B"},{"name":"Elapse","code":"CSE44","hex":"#3E4E50"},{"name":"Forward","code":"CSE14","hex":"#16191D"}];
function eraByCode(code){return ERA_COLOURS.find(c=>c.code===code)||ERA_COLOURS[0]}
function colourForUnit(unitIndex){return eraByCode(eraColours[unitIndex%eraColours.length]).hex}
function seededIndex(unitIndex,padIndex,count){
  let x=((unitIndex+1)*73856093)^((padIndex+1)*19349663);
  x=(x^(x>>>13))*1274126177; x=x^(x>>>16);
  return Math.abs(x)%count;
}
function applyUpholstery(root,unitIndex){
  let padIndex=0;
  root.traverse(o=>{
    if(!o.isMesh || !o.userData.huxloPadStyle || !o.visible)return;
    const idx=colourArrangement==='pad' && eraColours.length>1
      ? seededIndex(unitIndex,padIndex++,eraColours.length)
      : unitIndex%eraColours.length;
    const hex=eraByCode(eraColours[idx]).hex;
    const mats=Array.isArray(o.material)?o.material:[o.material];
    mats.filter(Boolean).forEach(m=>{
      if(baseName(m.name)==='FABRIC' || o.userData.huxloPadStyle){
        if(m.color)m.color.set(hex);m.needsUpdate=true;
      }
    });
  });
}
let unitCounter=0;


const loader=new GLTFLoader();
const MODEL_VERSION='35';
const load=(url,{silent=false}={})=>new Promise((res,rej)=>{
  const sep=url.includes('?')?'&':'?';
  if(!silent)beginModelLoad();
  loader.load(
    `${url}${sep}v=${MODEL_VERSION}`,
    g=>{if(!silent)endModelLoad();res(g.scene)},
    undefined,
    e=>{if(!silent)endModelLoad();rej(e)}
  );
});
let base01,base01storage,base02,base04,base06,base14,base04800,base09,base10;
let masterBirchMaterial=null,masterFabricMaterial=null;
const modelPromises=new Map();
const modelGetters={TS01:()=>base01,TS01_STORAGE:()=>base01storage,TS02:()=>base02,TS04:()=>base04,TS06:()=>base06,TS14:()=>base14,TS04_800:()=>base04800,TS09:()=>base09,TS10:()=>base10};
const modelSetters={TS01:v=>base01=v,TS01_STORAGE:v=>base01storage=v,TS02:v=>base02=v,TS04:v=>base04=v,TS06:v=>base06=v,TS14:v=>base14=v,TS04_800:v=>base04800=v,TS09:v=>base09=v,TS10:v=>base10=v};
function captureMasterMaterials(root){
  root.traverse(o=>{
    if(!o.isMesh)return;
    const mats=Array.isArray(o.material)?o.material:[o.material];
    if(!masterBirchMaterial){
      const birch=mats.find(m=>m&&baseName(m.name)==='BIRCH'&&m.map);
      if(birch)masterBirchMaterial=birch;
    }
    if(!masterFabricMaterial){
      const fabric=mats.find(m=>m&&baseName(m.name)==='FABRIC'&&m.map);
      if(fabric)masterFabricMaterial=fabric;
    }
  });
  if(!masterBirchMaterial)console.warn('TS01 loaded, but no textured BIRCH material was found.');
  if(!masterFabricMaterial)console.warn('TS01 loaded, but no textured FABRIC material was found.');
}
function applyMasterMaterials(root){
  root.traverse(o=>{
    if(!o.isMesh||!o.material)return;
    const replace=m=>{
      if(!m)return m;
      const name=baseName(m.name);
      const master=name==='BIRCH'?masterBirchMaterial:name==='FABRIC'?masterFabricMaterial:null;
      if(!master)return m;
      const r=master.clone();
      r.name=m.name||master.name;
      r.userData={...(master.userData||{}),...(m.userData||{})};
      return r;
    };
    o.material=Array.isArray(o.material)?o.material.map(replace):replace(o.material);
  });
}
async function ensureModel(key,{silent=false}={}){
  if(modelGetters[key]?.())return modelGetters[key]();
  if(modelPromises.has(key))return modelPromises.get(key);
  const task=(async()=>{
    // TS01 is the master material source, so every other model waits for it once.
    if(key!=='TS01')await ensureModel('TS01',{silent:true});
    const model=await load(window.HUXLO_BASECAMP_ASSETS[key],{silent});
    markPadMeshes(model);
    if(key==='TS01')captureMasterMaterials(model);else applyMasterMaterials(model);
    modelSetters[key](model);
    return model;
  })();
  modelPromises.set(key,task);
  try{return await task}catch(e){modelPromises.delete(key);throw e}
}

const BACKGROUND_PRELOAD_ORDER=['TS02','TS04','TS06','TS14','TS01_STORAGE','TS04_800','TS09','TS10'];
let backgroundPreloadStarted=false;
async function preloadRemainingModels(){
  if(backgroundPreloadStarted)return;
  backgroundPreloadStarted=true;
  // Let the initial TS01 assembly paint first, then quietly fill the model cache.
  await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
  for(const key of BACKGROUND_PRELOAD_ORDER){
    try{await ensureModel(key,{silent:true})}
    catch(e){console.warn(`Background preload failed for ${key}`,e)}
  }
}
function requiredModelKeys(){
  const keys=new Set(['TS01']);
  if(layout==='l'||layout==='u')keys.add('TS02');
  if(designThird||third){keys.add('TS04');if(stepSlots.main.length)keys.add('TS04_800')}
  if([...bayOverrides.values()].includes('TS06'))keys.add('TS06');
  if(storageBays.size)keys.add('TS01_STORAGE');
  if(stepSlots.main.length||stepSlots.left.length||stepSlots.right.length)keys.add('TS14');
  if(barrierBays.size)keys.add('TS09');
  if(sideBarrierBays.size)keys.add('TS10');
  return [...keys];
}
let buildRequest=0;let mainBays=4.8,returnBays=3.6,returnBays2=3.6,third=false,square=true,finish='birch',rear=.8,layout='straight',returnOffsetX=1.2,returnOffsetY=-1.2,seatTarget=24,thirdMode='auto',configMode='design',designMain=3,designReturn=3,designReturn2=3,designThird=false,eraColours=['CSE21'],colourArrangement='unit';const assembly=new THREE.Group();scene.add(assembly);
const dimensionGroup=new THREE.Group();scene.add(dimensionGroup);
const wallGroup=new THREE.Group();scene.add(wallGroup);let wallsVisible=false;
let currentConfig=null;
const bayOverrides=new Map(); const storageBays=new Set(); const barrierBays=new Set(); const sideBarrierBays=new Set(); let selectedBayKey=null;
let hoveredBayKey=null;
const stepSlots={main:[],left:[],right:[]};let historyStack=[],redoStack=[],historyReady=false,isRestoring=false,lastStateJSON='';const LOCAL_PREFIX='huxlo-basecamp-design:';
function designState(){return {v:2,layout,third:!!designThird,designThird:!!designThird,square,finish,colourArrangement,designMain,designReturn,designReturn2,eraColours:[...eraColours],bayOverrides:[...bayOverrides.entries()],storageBays:[...storageBays],barrierBays:[...barrierBays],sideBarrierBays:[...sideBarrierBays],stepSlots:{main:[...stepSlots.main],left:[...stepSlots.left],right:[...stepSlots.right]}}}
function snapshot(){return JSON.stringify(designState())}
function recordState(){if(isRestoring)return;const now=snapshot();if(!historyReady){historyReady=true;lastStateJSON=now;updateHistoryUI();return}if(now===lastStateJSON)return;historyStack.push(lastStateJSON);if(historyStack.length>80)historyStack.shift();redoStack=[];lastStateJSON=now;updateHistoryUI()}
function updateHistoryUI(){if(typeof undoBtn!=='undefined'){undoBtn.disabled=!historyStack.length;redoBtn.disabled=!redoStack.length}}function syncRestoredUI(){
  straightBtn.classList.toggle('active',layout==='straight');lBtn.classList.toggle('active',layout==='l');uBtn.classList.toggle('active',layout==='u');
  designThirdToggle.checked=!!designThird;
  squareBtn.classList.toggle('active',!!square);rectangleBtn.classList.toggle('active',!square);
  birchBtn.classList.toggle('active',finish==='birch');oakBtn.classList.toggle('active',finish==='oak');
  document.getElementById('designMain').value=designMain;designMainValue.textContent=designMain;
  document.getElementById('designReturn').value=designReturn;designReturnValue.textContent=designReturn;
  document.getElementById('designReturn2').value=designReturn2;designReturn2Value.textContent=designReturn2;
  updateModeUI();
  // Saved upholstery state must be reflected in the sidebar as well as the 3D model.
  if(typeof renderSelectedEra==='function')renderSelectedEra();
  if(typeof alternateUnitBtn!=='undefined'){
    alternateUnitBtn.classList.toggle('active',colourArrangement==='unit');
    randomPadBtn.classList.toggle('active',colourArrangement==='pad');
  }
}
function applyState(st){isRestoring=true;layout=st.layout||'straight';designThird=st.designThird!==undefined?!!st.designThird:!!st.third;third=designThird;square=st.square!==false;finish=st.finish||'birch';colourArrangement=st.colourArrangement||'unit';designMain=st.designMain??designMain;designReturn=st.designReturn??designReturn;designReturn2=st.designReturn2??designReturn2;eraColours=st.eraColours?.length?[...st.eraColours]:['CSE21'];bayOverrides.clear();(st.bayOverrides||[]).forEach(([k,v])=>bayOverrides.set(k,v));storageBays.clear();(st.storageBays||[]).forEach(k=>storageBays.add(k));barrierBays.clear();(st.barrierBays||[]).forEach(k=>barrierBays.add(k));sideBarrierBays.clear();(st.sideBarrierBays||[]).forEach(k=>sideBarrierBays.add(k));for(const r of ['main','left','right'])stepSlots[r].splice(0,stepSlots[r].length,...(st.stepSlots?.[r]||[]));configMode='design';syncRestoredUI();build(false);isRestoring=false;lastStateJSON=snapshot();updateHistoryUI()}
function undoDesign(){if(!historyStack.length)return;redoStack.push(lastStateJSON);applyState(JSON.parse(historyStack.pop()))}function redoDesign(){if(!redoStack.length)return;historyStack.push(lastStateJSON);applyState(JSON.parse(redoStack.pop()))}
let activeDesignId=null,activeDesignUrl=null;
function designLink(id){if(IS_EMBEDDED)return `${location.origin}/pages/basecamp-configurator?design=${encodeURIComponent(id)}`;const u=new URL(location.href);u.search='';u.searchParams.set('design',id);return u.toString()}
async function saveBackendDesign(meta={}){
  const body={designId:activeDesignId,project:'',email:meta.email||'',configuration:{state:designState(),specification:currentConfig||null}};
  const response=await fetch(DESIGN_API_URL,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
  const data=await response.json().catch(()=>({}));
  if(!response.ok||!data.ok)throw new Error(data.error||`Save failed (${response.status})`);
  activeDesignId=data.designId;activeDesignUrl=data.designUrl||designLink(activeDesignId);
  if(!IS_EMBEDDED){const u=new URL(location.href);u.searchParams.set('design',activeDesignId);history.replaceState(null,'',u);}
  return {id:activeDesignId,link:activeDesignUrl};
}
async function loadDesignFromURL(){
  const id=(IS_EMBEDDED?CONFIGURATOR_ROOT?.dataset.designId:null)||new URL(location.href).searchParams.get('design');if(!id)return false;
  try{
    const response=await fetch(`${DESIGN_API_URL}/${encodeURIComponent(id)}`,{cache:'no-store'});
    const data=await response.json().catch(()=>({}));
    if(!response.ok||!data.ok||!data.design)throw new Error(data.error||'Design not found');
    const cfg=data.design.configuration||{};const state=cfg.state||cfg;
    activeDesignId=data.design.designId||id;activeDesignUrl=designLink(activeDesignId);
    applyState(state);return true;
  }catch(e){console.warn('Could not load saved design',e);return false}
}
function numericVariantId(gid){return Number(String(gid||'').split('/').pop())}
function fabricSummary(){return currentConfig?.fabrics?.map(f=>`${f.name} ${f.code}`).join(' / ')||eraColours.join(' / ')}
async function addConfigurationToCart(){
  const btn=document.getElementById('addToCartBtn');const original=btn.textContent;btn.disabled=true;btn.textContent='Saving design…';
  try{
    if(pricingSource!=='live')throw new Error('Live Shopify variants are not available yet. Please refresh and try again.');
    if(!currentConfig?.commercial?.allMapped)throw new Error('One or more modules are not mapped to a Shopify variant.');
    const saved=await saveBackendDesign();
    btn.textContent='Adding to cart…';
    const props={'Design ID':saved.id,'Fabric colours':fabricSummary(),'Fabric layout':currentConfig.colourArrangement};
    const items=currentConfig.commercial.lines.filter(l=>l.qty>0).map(l=>{const v=variantFor(l.module),id=numericVariantId(v?.variantId);if(!id)throw new Error(`No Shopify variant ID for ${l.sku}`);return {id,quantity:l.qty,properties:props}});
    const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    const data=await response.json().catch(()=>({}));if(!response.ok)throw new Error(data.description||data.message||`Cart error (${response.status})`);
    location.href='/cart';
  }catch(e){console.error(e);alert(e.message||'Could not add this configuration to the cart.');btn.disabled=false;btn.textContent=original}
}


const interactionGroup=new THREE.Group();scene.add(interactionGroup);
function fit(){const box=new THREE.Box3().setFromObject(assembly);if(box.isEmpty())return;const size=box.getSize(new THREE.Vector3()),center=box.getCenter(new THREE.Vector3());controls.target.copy(center);const max=Math.max(size.x,size.y,size.z);camera.position.set(center.x+max*1.45,center.y+max*.95,center.z+max*1.5);camera.near=.01;camera.far=100;camera.updateProjectionMatrix();controls.update()}
function addEdgeLines(root){
  const meshes=[]; root.traverse(o=>{if(o.isMesh && !o.userData.huxloEdgeOverlay)meshes.push(o)});
  meshes.forEach(mesh=>{
    const edges=new THREE.EdgesGeometry(mesh.geometry,35);
    const mat=new THREE.LineBasicMaterial({color:0x111111,transparent:true,opacity:.72,depthTest:true});
    const lines=new THREE.LineSegments(edges,mat); lines.userData.huxloEdgeOverlay=true; lines.renderOrder=2; mesh.add(lines);
  });
}
function prep(model,unitIndex=0){
  const c=model.clone(true);
  cloneMaterialTree(c);setPads(c,square);tintConfigurable(c,finish);applyUpholstery(c,unitIndex);addEdgeLines(c);
  return c;
}
function addThirdTierBehind(x,z,rot=0,frontUnitIndex=0,mirror=false,extraMainOffset=0,extraXOffset=0){
  // TS04 copies the front unit's upholstery and, for the mirrored U corner, its handedness.
  const t=prep(base04,frontUnitIndex);
  if(mirror)t.scale.x*=-1;
  const a=THREE.MathUtils.degToRad(rot);
  const dx=-rear*Math.cos(a), dz=rear*Math.sin(a);
  t.position.set(x+dx+extraXOffset,0,z+dz+extraMainOffset);
  t.rotation.y=a;
  assembly.add(t);
}
function capacityFor(mainCount, returnCount, useThird, returnCount2=0){
  let base,thirdSeats=0;
  if(layout==='straight'){base=mainCount*6;if(useThird)thirdSeats=mainCount*3;}
  else if(layout==='l'){base=mainCount*6+3+returnCount*6;if(useThird)thirdSeats=(mainCount+1)*3;}
  else {base=mainCount*6+6+returnCount*6+returnCount2*6;if(useThird)thirdSeats=(mainCount+2)*3;}
  return base+thirdSeats;
}
function solveLayout(){
  const mb=Math.floor((mainBays+1e-9)/1.2);
  const rb=Math.floor((returnBays+1e-9)/1.2);
  const rb2=Math.floor((returnBays2+1e-9)/1.2);
  const corners=layout==='straight'?0:(layout==='l'?1:2);
  const maxMain=Math.max(0,mb-corners);
  const maxReturn=layout==='straight'?0:Math.max(0,rb-1);
  const maxReturn2=layout==='u'?Math.max(0,rb2-1):0;

  if((layout==='l'&&(mb<1||rb<1))||(layout==='u'&&(mb<3||rb<1||rb2<1)))
    return {m:0,r:0,r2:0,t:false,cap:0,fits:false};

  const candidates=[];
  const minMain=layout==='straight'?1:(layout==='u'?1:0);

  for(let m=minMain;m<=maxMain;m++){
    const rMax=layout==='straight'?0:maxReturn;
    const r2Max=layout==='u'?maxReturn2:0;
    for(let r=0;r<=rMax;r++){
      for(let r2=0;r2<=r2Max;r2++){
        // Straight must contain at least one TS01. L/U may consist of their corner bay(s).
        const thirdOptions=thirdMode==='auto'?[false,true]:[false];
        for(const t of thirdOptions){
          const cap=capacityFor(m,r,t,r2);
          if(cap<seatTarget) continue;
          const moduleCount=m+r+r2+(layout==='straight'?0:(layout==='l'?1:2))
            +(t?(layout==='straight'?m:(layout==='l'?m+1:m+2)):0);
          const footprintBays=m+r+r2+(layout==='straight'?0:(layout==='l'?2:4));
          candidates.push({m,r,r2,t,cap,fits:true,moduleCount,footprintBays});
        }
      }
    }
  }

  if(candidates.length){
    function balanceScore(c){
      if(layout==='straight') return 0;
      // Compare total leg bay counts, including shared corner bay(s).
      if(layout==='l'){
        const mainLeg=c.m+1, returnLeg=c.r+1;
        return Math.abs(mainLeg-returnLeg);
      }
      // U: favour all three legs being similar.
      const mainLeg=c.m+2, leftLeg=c.r+1, rightLeg=c.r2+1;
      return Math.max(mainLeg,leftLeg,rightLeg)-Math.min(mainLeg,leftLeg,rightLeg);
    }
    candidates.sort((a,b)=>
      Number(a.t)-Number(b.t) ||                // use a third tier only when no 2-tier solution can meet the target
      (a.cap-seatTarget)-(b.cap-seatTarget) ||  // then minimise spare capacity
      balanceScore(a)-balanceScore(b) ||        // keep L/U legs as even as possible
      (layout==='l' ? (b.m-a.m) : 0) ||         // for an L tie, favour the main run rather than the return
      a.moduleCount-b.moduleCount ||             // then fewer modules
      a.footprintBays-b.footprintBays            // then smaller footprint
    );
    return candidates[0];
  }

  // Nothing can meet the target: show the highest-capacity valid option available.
  const t=thirdMode==='auto';
  const cap=capacityFor(maxMain,maxReturn,t,maxReturn2);
  return {m:maxMain,r:maxReturn,r2:maxReturn2,t,cap,fits:false};
}

function makeTextSprite(text){
  const c=document.createElement('canvas');c.width=512;c.height=128;
  const ctx=c.getContext('2d');ctx.clearRect(0,0,c.width,c.height);
  ctx.font='600 48px Arial';ctx.textAlign='center';ctx.textBaseline='middle';
  const w=Math.min(480,ctx.measureText(text).width+42);
  ctx.fillStyle='rgba(255,255,255,.94)';ctx.fillRect((512-w)/2,26,w,76);
  ctx.fillStyle='#111';ctx.fillText(text,256,64);
  const tex=new THREE.CanvasTexture(c);tex.colorSpace=THREE.SRGBColorSpace;
  const mat=new THREE.SpriteMaterial({map:tex,transparent:true,depthTest:true});
  const sp=new THREE.Sprite(mat);sp.scale.set(1.25,.31,1);sp.renderOrder=20;return sp;
}
function lineBetween(a,b){
  const geo=new THREE.BufferGeometry().setFromPoints([a,b]);
  const mat=new THREE.LineBasicMaterial({color:0x111111,depthTest:true});
  const l=new THREE.Line(geo,mat);l.renderOrder=19;dimensionGroup.add(l);
}
function physicalAssemblyBox(){
  const box=new THREE.Box3();
  assembly.traverse(o=>{
    if(!o.isMesh||o.userData?.huxloHitBox||o.visible===false)return;
    if(!o.geometry)return;
    if(!o.geometry.boundingBox)o.geometry.computeBoundingBox();
    const b=o.geometry.boundingBox.clone();b.applyMatrix4(o.matrixWorld);box.union(b);
  });
  return box;
}
function updateDimensions(){
  dimensionGroup.clear();assembly.updateMatrixWorld(true);
  const box=physicalAssemblyBox();if(box.isEmpty())return;
  const size=box.getSize(new THREE.Vector3());
  const y=.06, off=.42, tick=.12;
  // X/main-run dimension: original side of the design in plan.
  const z=box.max.z+off;
  lineBetween(new THREE.Vector3(box.min.x,y,z),new THREE.Vector3(box.max.x,y,z));
  lineBetween(new THREE.Vector3(box.min.x,y,z-tick),new THREE.Vector3(box.min.x,y,z+tick));
  lineBetween(new THREE.Vector3(box.max.x,y,z-tick),new THREE.Vector3(box.max.x,y,z+tick));
  const sx=makeTextSprite(`${size.x.toFixed(1)} m`);
  sx.position.set((box.min.x+box.max.x)/2,y+.03,z+0.16);dimensionGroup.add(sx);
  // Y/plan-depth dimension (Three.js Z): opposite side of the design.
  const x=box.max.x+off;
  lineBetween(new THREE.Vector3(x,y,box.min.z),new THREE.Vector3(x,y,box.max.z));
  lineBetween(new THREE.Vector3(x-tick,y,box.min.z),new THREE.Vector3(x+tick,y,box.min.z));
  lineBetween(new THREE.Vector3(x-tick,y,box.max.z),new THREE.Vector3(x+tick,y,box.max.z));
  const sz=makeTextSprite(`${size.z.toFixed(1)} m`);
  sz.position.set(x+0.16,y+.03,(box.min.z+box.max.z)/2);dimensionGroup.add(sz);
  currentConfig && (currentConfig.overallDimensions={x:size.x.toFixed(1),y:size.z.toFixed(1)});
}


function bayKey(run,index){return `${run}:${index}`}
function desiredBayType(run,index){
  const key=bayKey(run,index);
  // A main-run bay with a separate third tier must remain TS01.
  if(third && run==='main') return 'TS01';
  return bayOverrides.get(key)==='TS06'?'TS06':'TS01';
}

function addBayHitBox(root,run,index){
  root.updateMatrixWorld(true);
  const box=new THREE.Box3().setFromObject(root), size=box.getSize(new THREE.Vector3()), center=box.getCenter(new THREE.Vector3());
  // Convert the world-space box centre back into the module's local coordinates.
  // This is important for positioned/rotated TS14 modules.
  root.worldToLocal(center);
  const geo=new THREE.BoxGeometry(Math.max(.05,size.x*.94),Math.max(.15,size.y),Math.max(.05,size.z*.94));
  const mat=new THREE.MeshBasicMaterial({transparent:true,opacity:0,depthWrite:false});
  const hit=new THREE.Mesh(geo,mat);hit.position.copy(center);hit.userData.huxloHitBox=true;hit.userData.huxloBayKey=bayKey(run,index);
  root.add(hit);
}
function applyBayVisuals(){
  assembly.traverse(o=>{
    if(!o.userData?.huxloSelectable)return;
    const key=o.userData.huxloBayKey, selected=key===selectedBayKey, hovered=key===hoveredBayKey;
    o.traverse(m=>{
      if(!m.isMesh||m.userData.huxloHitBox)return;
      const mats=Array.isArray(m.material)?m.material:[m.material];
      mats.filter(Boolean).forEach(mat=>{
        if(!mat.userData.huxloBaseEmissive && mat.emissive) mat.userData.huxloBaseEmissive='#'+mat.emissive.getHexString();
        if(mat.emissive){
          if(selected)mat.emissive.set('#e7ebee');
          else if(hovered)mat.emissive.set('#f3f5f6');
          else mat.emissive.set(mat.userData.huxloBaseEmissive||'#000000');
          mat.needsUpdate=true;
        }
      });
    });
  });
}


function slotKey(run,slot){return `step:${run}:${slot}`}
function stepsBefore(run,slot){return stepSlots[run].filter(v=>v<slot).length}
function hasStep(run,slot){return stepSlots[run].includes(slot)}
function addStepThirdTier(x,z,rot=0,unitIndex=0){
  if(!base04800)return;
  const t=prep(base04800,unitIndex), a=THREE.MathUtils.degToRad(rot);
  const dx=-rear*Math.cos(a),dz=rear*Math.sin(a);
  t.position.set(x+dx,0,z+dz);t.rotation.y=a;assembly.add(t);
}
function makeIconSprite(text,kind,run,slot,x,z,baseScale=.16){
  const c=document.createElement('canvas');c.width=128;c.height=128;const ctx=c.getContext('2d');
  ctx.beginPath();ctx.arc(64,64,44,0,Math.PI*2);ctx.fillStyle='rgba(20,20,20,.96)';ctx.fill();
  ctx.strokeStyle='#111';ctx.lineWidth=2;ctx.stroke();ctx.font='600 56px Arial';ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillStyle='#fff';ctx.fillText(text,64,61);
  const tex=new THREE.CanvasTexture(c),mat=new THREE.SpriteMaterial({map:tex,transparent:true,depthTest:false});
  const sp=new THREE.Sprite(mat);sp.scale.set(baseScale,baseScale,baseScale);sp.position.set(x,.16,z);
  sp.userData.huxloInsert=kind==='insert';sp.userData.huxloMove=kind==='move';sp.userData.huxloDelete=kind==='delete';sp.userData.run=run;sp.userData.slot=slot;
  sp.userData.dir=text==='←'?-1:text==='→'?1:0;sp.userData.baseScale=baseScale;
  interactionGroup.add(sp);return sp;
}
function makePlusSprite(run,slot,x,z){return makeIconSprite('+','insert',run,slot,x,z,.19)}
function makeMoveArrow(text,run,slot,x,z){return makeIconSprite(text,'move',run,slot,x,z,.23)}
function makeTrash(run,slot,x,z){
  const sp=makeIconSprite('×','delete',run,slot,x,z,.21);
  return sp;
}
function updateInteractionSprites(){
  interactionGroup.traverse(o=>{
    if(!o.isSprite)return;
    const base=o.userData.baseScale||.15;
    const hot=o.userData.huxloHot===true;
    const sc=hot?base*1.45:base;
    o.scale.set(sc,sc,sc);
  });
}
function addStep(run,slot){
  if(!hasStep(run,slot)){stepSlots[run].push(slot);stepSlots[run].sort((a,b)=>a-b)}
  selectedBayKey=slotKey(run,slot);hoveredBayKey=null;build(false);
}
function moveStep(run,slot,dir){
  const max=run==='main'?currentPlanGapCounts.main:run==='left'?currentPlanGapCounts.left:currentPlanGapCounts.right;
  const min=run==='main'&&layout!=='u'?0:1;
  const target=slot+dir;if(target<min||target>max||hasStep(run,target))return;
  stepSlots[run]=stepSlots[run].filter(v=>v!==slot);stepSlots[run].push(target);stepSlots[run].sort((a,b)=>a-b);
  selectedBayKey=slotKey(run,target);build(false);
}
function removeStep(run,slot){stepSlots[run]=stepSlots[run].filter(v=>v!==slot);selectedBayKey=null;build(false)}
let currentPlanGapCounts={main:0,left:0,right:0};

function addBarrierToModule(module,key,type){
  if(!base09||!barrierBays.has(key)||(type!=='TS01'&&type!=='TS02'))return;
  if(third && (key.startsWith('main:') || key==='corner:left' || key==='corner:right'))return;
  const b=prep(base09,-1);b.position.copy(module.position);b.rotation.copy(module.rotation);b.scale.copy(module.scale);
  b.userData.huxloBarrier=true;b.userData.huxloBarrierKey=key;assembly.add(b);
}
function addSideBarrierToTS02(module,key){
  if(!base10||!sideBarrierBays.has(key))return;
  const b=prep(base10,-1);b.position.copy(module.position);b.rotation.copy(module.rotation);b.scale.copy(module.scale);
  b.userData.huxloSideBarrier=true;b.userData.huxloSideBarrierKey=key;assembly.add(b);
}
function setBarrier(key,on){if(on && third && (key.startsWith('main:')||key==='corner:left'||key==='corner:right'))return;if(on)barrierBays.add(key);else barrierBays.delete(key);build(false)}
function setSideBarrier(key,on){if(!key||!key.startsWith('corner:'))return;if(on)sideBarrierBays.add(key);else sideBarrierBays.delete(key);build(false)}
function allBarrierKeys(){const keys=[];assembly.traverse(o=>{if(o.userData?.huxloSelectable&&(o.userData.huxloBayType==='TS01'||o.userData.huxloBayType==='TS02'))keys.push(o.userData.huxloBayKey)});return [...new Set(keys)]}
function prepBay(run,index,unitIndex){
  const type=desiredBayType(run,index),key=bayKey(run,index);
  const model=(type==='TS06'&&base06)?base06:(type==='TS01'&&storageBays.has(key)&&base01storage)?base01storage:base01;
  const c=prep(model,unitIndex);
  c.userData.huxloSelectable=true;c.userData.huxloBayKey=bayKey(run,index);c.userData.huxloBayType=type;c.userData.huxloStorage=(type==='TS01'&&storageBays.has(key));c.userData.huxloRun=run;c.userData.huxloBayIndex=index;
  addBayHitBox(c,run,index);
  return c;
}
function sanitizeBayOverrides(){
  // When third tier is enabled, TS06 is invalid on the main row. Convert those bays back to TS01.
  if(third){
    [...bayOverrides.keys()].filter(k=>k.startsWith('main:')).forEach(k=>bayOverrides.delete(k));
  }
}
function updateSelectionPanel(){
  const panel=document.getElementById('selectionPanel');if(!selectedBayKey){panel.hidden=true;return}
  if(selectedBayKey.startsWith('step:')){
    const [,run,slotText]=selectedBayKey.split(':'),slot=+slotText;if(!hasStep(run,slot)){selectedBayKey=null;panel.hidden=true;return}
    panel.hidden=false;selectionName.textContent='TS14 Steps';
    seatModuleControls.hidden=true;seatModuleControls.style.display='none';storageModuleControls.hidden=true;storageModuleControls.style.display='none';
    barrierModuleControls.hidden=true;barrierModuleControls.style.display='none';sideBarrierModuleControls.hidden=true;sideBarrierModuleControls.style.display='none';
    accessModuleControls.hidden=true;accessModuleControls.style.display='none';stepModuleControls.hidden=false;stepModuleControls.style.display='block';
    const min=run==='main'&&layout!=='u'?0:1,max=currentPlanGapCounts[run];
    stepLeft.disabled=slot<=min||hasStep(run,slot-1);stepRight.disabled=slot>=max||hasStep(run,slot+1);
    selectionNote.textContent='Move or remove this TS14 access module.';return;
  }
  let target=null;assembly.traverse(o=>{if(o.userData?.huxloSelectable&&o.userData.huxloBayKey===selectedBayKey)target=o});
  if(!target){selectedBayKey=null;panel.hidden=true;return}
  panel.hidden=false;stepModuleControls.hidden=true;stepModuleControls.style.display='none';
  const type=target.userData.huxloBayType,isCorner=type==='TS02';
  seatModuleControls.hidden=isCorner;seatModuleControls.style.display=isCorner?'none':'';
  storageModuleControls.hidden=type!=='TS01';storageModuleControls.style.display=type==='TS01'?'flex':'none';storageCheckbox.checked=type==='TS01'&&storageBays.has(selectedBayKey);
  const rearBarrierAllowed=(type==='TS01'||type==='TS02')&&!(third&&(target.userData.huxloRun==='main'||isCorner));
  barrierModuleControls.hidden=!rearBarrierAllowed;barrierModuleControls.style.display=rearBarrierAllowed?'flex':'none';
  sideBarrierModuleControls.hidden=!isCorner;sideBarrierModuleControls.style.display=isCorner?'flex':'none';
  const canAddAccess=type==='TS01'||type==='TS06';accessModuleControls.hidden=!canAddAccess;accessModuleControls.style.display=canAddAccess?'block':'none';
  if(canAddAccess){
    const run=target.userData.huxloRun,index=target.userData.huxloBayIndex;
    const beforeSlot=run==='main'?(layout==='u'?index+1:index):index+1;
    const afterSlot=run==='main'?(layout==='u'?index+2:index+1):index+2;
    const min=run==='main'&&layout!=='u'?0:1,max=currentPlanGapCounts[run];
    const beforeValid=index===0&&beforeSlot>=min&&beforeSlot<=max&&!hasStep(run,beforeSlot),afterValid=afterSlot>=min&&afterSlot<=max&&!hasStep(run,afterSlot);
    addStairsBefore.hidden=!beforeValid;addStairsAfter.hidden=!afterValid;accessButtons.classList.toggle('one',beforeValid!==afterValid);
    accessModuleControls.hidden=!(beforeValid||afterValid);accessModuleControls.style.display=(beforeValid||afterValid)?'block':'none';
    addStairsBefore.dataset.run=run;addStairsBefore.dataset.slot=beforeSlot;addStairsAfter.dataset.run=run;addStairsAfter.dataset.slot=afterSlot;
  }
  const runLabel=isCorner?'Corner':target.userData.huxloRun==='main'?'Main run':target.userData.huxloRun==='left'?'Left return':'Right return';
  selectionName.textContent=isCorner?'TS02 corner':`${runLabel} · Bay ${target.userData.huxloBayIndex+1}`;
  selectTS01.classList.toggle('active',type==='TS01');selectTS06.classList.toggle('active',type==='TS06');
  const locked=third&&target.userData.huxloRun==='main';selectTS06.disabled=locked;
  barrierCheckbox.checked=barrierBays.has(target.userData.huxloBayKey);sideBarrierCheckbox.checked=sideBarrierBays.has(target.userData.huxloBayKey);
  selectionNote.textContent=isCorner?'TS09 rear and TS10 side barriers can be added to this TS02.':locked?'TS06 is unavailable on the main row while the third tier is enabled.':'TS06 replaces this TS01 bay and occupies the full three-tier height.';
}
function setSelectedBayType(type){
  if(!selectedBayKey)return;
  const [run]=selectedBayKey.split(':');
  if(type==='TS06'&&third&&run==='main')return;
  if(type==='TS06'){bayOverrides.set(selectedBayKey,'TS06');storageBays.delete(selectedBayKey);barrierBays.delete(selectedBayKey)}else bayOverrides.delete(selectedBayKey);
  build(false);updateSelectionPanel();
  applyBayVisuals();
}


function objectBoxFor(predicate){
  const box=new THREE.Box3(),tmp=new THREE.Box3();let found=false;
  assembly.updateMatrixWorld(true);
  assembly.traverse(o=>{
    if(!o.isMesh||!o.visible||o.userData?.huxloHitBox||o.userData?.huxloEdgeOverlay)return;
    let root=o;while(root.parent&&root.parent!==assembly)root=root.parent;
    if(!predicate(root,o))return;
    tmp.setFromObject(o);if(!tmp.isEmpty()){box.union(tmp);found=true}
  });
  return found?box:null;
}
function makeWall(sizeX,sizeZ,x,z){
  const geo=new THREE.BoxGeometry(sizeX,2,sizeZ);
  const mat=new THREE.MeshStandardMaterial({color:0xffffff,roughness:.96,metalness:0});
  const wall=new THREE.Mesh(geo,mat);wall.position.set(x,1,z);wall.userData.huxloContextWall=true;wallGroup.add(wall);
}
function rebuildWalls(){
  wallGroup.clear();wallGroup.visible=wallsVisible;if(!wallsVisible)return;
  assembly.updateMatrixWorld(true);
  const allBox=physicalAssemblyBox();
  const mainBox=objectBoxFor(root=>root.userData?.huxloRun==='main'||root.userData?.huxloRun==='corner'||!root.userData?.huxloSelectable);
  const mb=mainBox||allBox;if(!mb||mb.isEmpty())return;
  const wallX=mb.min.x-.02-.05;

  // Main wall: Straight extends 1.2 m beyond the furniture at both ends.
  // L/U stays aligned to the main run so it can meet the return wall cleanly.
  let zMin=Infinity,zMax=-Infinity;
  assembly.children.forEach(root=>{
    const run=root.userData?.huxloRun;
    if(run==='left'||run==='right'||root.userData?.huxloHitBox)return;
    const b=new THREE.Box3().setFromObject(root);if(b.isEmpty())return;
    zMin=Math.min(zMin,b.min.z);zMax=Math.max(zMax,b.max.z);
  });
  if(!isFinite(zMin)){zMin=mb.min.z;zMax=mb.max.z}
  if(layout==='straight'){zMin-=1.2;zMax+=1.2}
  else {zMin-=0.02}
  makeWall(.1,Math.max(.1,zMax-zMin),wallX,(zMin+zMax)/2);

  // L/U: extend the left-return wall back toward the main wall by 1.32 m.
  // 1.20 m closes the TS02 bay gap, plus 0.02 m furniture clearance and
  // 0.10 m wall thickness so the two wall solids overlap/join cleanly.
  if(layout==='l'||layout==='u'){
    const lb=objectBoxFor(root=>root.userData?.huxloRun==='left');
    if(lb&&!lb.isEmpty()){
      const wallZ=lb.min.z-.02-.05;
      const thirdTierExtension=third?0.8:0;
      const joinExtension=1.32+thirdTierExtension;
      const xMin=lb.min.x-joinExtension;
      const xMax=lb.max.x;
      makeWall(Math.max(.1,xMax-xMin),.1,(xMin+xMax)/2,wallZ);
    }
  }
}

function money(v){return new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',minimumFractionDigits:0,maximumFractionDigits:0}).format(v)}
function variantFor(module){
  const upholstered=!['TS14','TS09','TS10'].includes(module);
  return SHOPIFY_VARIANTS.find(v=>v.module===module&&v.finish===finish&&(!upholstered||v.pads===(square?'square':'rectangle')))||null;
}
function commercialSchedule(modules){
  const order=['TS01','TS01_STORAGE','TS02','TS04','TS04_800','TS06','TS14','TS09','TS10'];
  const labels={TS01:'TS01',TS01_STORAGE:'TS01 Storage',TS02:'TS02',TS04:'TS04',TS04_800:'TS04 800',TS06:'TS06',TS14:'TS14 Steps',TS09:'TS09 Rear barrier',TS10:'TS10 Side barrier'};
  return order.filter(k=>(modules[k]||0)>0).map(k=>{const v=variantFor(k),qty=modules[k]||0;return {module:k,label:labels[k],qty,sku:v?.sku||'Unmapped',unitPrice:v?.price??0,total:qty*(v?.price??0),mapped:!!v}});
}
function showPriceBreakdown(){
  if(!currentConfig?.commercial)return;
  const c=currentConfig.commercial;
  priceBreakdown.innerHTML=c.lines.map(l=>`<div class="price-row"><div><b>${l.label}</b><div class="sku">${l.sku}</div></div><div class="num">× ${l.qty}</div><div class="num">${money(l.unitPrice)}</div><div class="num"><b>${money(l.total)}</b></div></div>`).join('');
  priceModalTotal.textContent=money(c.total);const note=document.getElementById('priceNote');if(note)note.textContent=pricingSource==='live'?'':'Using fallback prices from the product export.';priceModal.hidden=false;
}
function buildNow(doFit=true){
  assembly.clear();interactionGroup.clear(); unitCounter=0; let plan;
  if(configMode==='wizard') plan=solveLayout();
  else {
    const corners=layout==='straight'?0:(layout==='l'?1:2);
    const dm=Math.max(0,designMain-corners), dr=layout==='straight'?0:Math.max(0,designReturn-1), dr2=layout==='u'?Math.max(0,designReturn2-1):0;
    const cap=capacityFor(dm,dr,designThird,dr2); plan={m:dm,r:dr,r2:dr2,t:designThird,cap,fits:true};
  }
  third=plan.t;
  sanitizeBayOverrides();
  if(plan.t){
    // TS04/TS04-800 occupies the rear of the main row, so rear barriers on the
    // TS01s and TS02 corners directly in front of that third tier are invalid.
    [...barrierBays].forEach(key=>{
      if(key.startsWith('main:') || key==='corner:left' || key==='corner:right') barrierBays.delete(key);
    });
  }
  // TS14 is an 800 mm insertion module. Each insertion shifts all later modules in that run.
  const mainGapMax=layout==='straight'?plan.m:layout==='l'?plan.m:plan.m+1;
  const leftGapMax=layout==='straight'?0:plan.r+1;
  const rightGapMax=layout==='u'?(plan.r2||0)+1:0;
  currentPlanGapCounts={main:mainGapMax,left:leftGapMax,right:rightGapMax};
  const minSlot={main:(layout==='straight'||layout==='l')?0:1,left:1,right:1};
  for(const run of ['main','left','right'])stepSlots[run]=stepSlots[run].filter(v=>v>=minSlot[run]&&v<=currentPlanGapCounts[run]);

  let mainStartZ=0;
  if(layout==='u'){
    const idx=unitCounter++; const c=prep(base02,idx); c.position.set(0,0,-1.2); c.rotation.y=Math.PI; c.scale.x*=-1;c.userData.huxloSelectable=true;c.userData.huxloBayKey='corner:right';c.userData.huxloBayType='TS02';c.userData.huxloRun='corner';c.userData.huxloBayIndex=0;addBayHitBox(c,'corner','right');assembly.add(c);addBarrierToModule(c,'corner:right','TS02');addSideBarrierToTS02(c,'corner:right');
    if(plan.t)addThirdTierBehind(0,-1.2,180,idx,true,0,-1.6); mainStartZ=-1.2;
  }
  // Main TS01/TS06 units; slot numbering follows the seating sequence.
  for(let i=0;i<plan.m;i++){
    const sequenceSlot=layout==='u'?i+1:i;
    const shift=stepsBefore('main',sequenceSlot+1)*.8;
    const z=mainStartZ-i*1.2-shift, idx=unitCounter++; const a=prepBay('main',i,idx); a.position.set(0,0,z); assembly.add(a);if(a.userData.huxloBayType==='TS01')addBarrierToModule(a,a.userData.huxloBayKey,'TS01');
    if(plan.t)addThirdTierBehind(0,z,0,idx);
  }
  // Insert main-run TS14s and their 800 mm third-tier partners.
  for(const slot of stepSlots.main){
    let z;
    if(layout==='u') z=mainStartZ-(slot-1)*1.2-(stepsBefore('main',slot)*.8);
    else if(slot===0) z=mainStartZ;
    else z=mainStartZ-slot*1.2-(stepsBefore('main',slot)*.8);
    const t=prep(base14,unitCounter++);t.position.set(0,0,z);t.userData.huxloSelectable=true;t.userData.huxloBayKey=slotKey('main',slot);t.userData.huxloBayType='TS14';t.userData.huxloRun='main';addBayHitBox(t,'main',`step${slot}`);assembly.add(t);
    if(plan.t)addStepThirdTier(0,z,0,unitCounter);
  }
  if(layout==='l'||layout==='u'){
    const mainShift=stepSlots.main.length*.8;
    const cornerZ=mainStartZ-plan.m*1.2-mainShift, idx=unitCounter++; const c=prep(base02,idx); c.position.set(0,0,cornerZ);c.userData.huxloSelectable=true;c.userData.huxloBayKey='corner:left';c.userData.huxloBayType='TS02';c.userData.huxloRun='corner';c.userData.huxloBayIndex=0;addBayHitBox(c,'corner','left');assembly.add(c);addBarrierToModule(c,'corner:left','TS02');addSideBarrierToTS02(c,'corner:left');
    if(plan.t)addThirdTierBehind(0,cornerZ,0,idx);
    for(let j=0;j<plan.r;j++){
      const shift=stepSlots.left.filter(v=>v<=j+1).length*.8;
      const x=returnOffsetX+j*1.2+shift;
      const r=prepBay('left',j,unitCounter++);r.position.set(x,0,cornerZ+returnOffsetY);r.rotation.y=-Math.PI/2;assembly.add(r);if(r.userData.huxloBayType==='TS01')addBarrierToModule(r,r.userData.huxloBayKey,'TS01');
    }
    for(const slot of stepSlots.left){
      const x=returnOffsetX+(slot-1)*1.2+stepsBefore('left',slot)*.8;
      const t=prep(base14,unitCounter++);t.position.set(x,0,cornerZ+returnOffsetY);t.rotation.y=-Math.PI/2;t.userData.huxloSelectable=true;t.userData.huxloBayKey=slotKey('left',slot);t.userData.huxloBayType='TS14';t.userData.huxloRun='left';addBayHitBox(t,'left',`step${slot}`);assembly.add(t);
    }
    if(layout==='u'){
      for(let j=0;j<(plan.r2||0);j++){
        const shift=stepSlots.right.filter(v=>v<=j+1).length*.8;
        const x=returnOffsetX+1.2+j*1.2+shift;
        const r=prepBay('right',j,unitCounter++);r.position.set(x,0,0);r.rotation.y=Math.PI/2;assembly.add(r);if(r.userData.huxloBayType==='TS01')addBarrierToModule(r,r.userData.huxloBayKey,'TS01');
      }
      for(const slot of stepSlots.right){
        const x=returnOffsetX+.8+(slot-1)*1.2+stepsBefore('right',slot)*.8;
        const t=prep(base14,unitCounter++);t.position.set(x,0,0);t.rotation.y=Math.PI/2;t.userData.huxloSelectable=true;t.userData.huxloBayKey=slotKey('right',slot);t.userData.huxloBayType='TS14';t.userData.huxloRun='right';addBayHitBox(t,'right',`step${slot}`);assembly.add(t);
      }
    }
  }
  // Stairs are added from the selected bay's Access controls.
  const msg=document.getElementById('capacityMessage');
  if(configMode==='design')msg.innerHTML=''; else if(plan.fits){msg.innerHTML=`Recommended configuration: <b>${plan.cap} seats</b>${plan.t?' with third tier':' without third tier'}.`;msg.style.color='#356b3f';} else {msg.innerHTML=`Maximum capacity in the available space is <b>${plan.cap} seats</b>. Increase the available space or reduce the seat requirement.`;msg.style.color='#9b3b31';}
  const corners=layout==='straight'?0:(layout==='l'?1:2),
    mainLen=((plan.m+corners)*1.2+stepSlots.main.length*.8).toFixed(1),
    retLen=((plan.r+(layout==='straight'?0:1))*1.2+stepSlots.left.length*.8).toFixed(1),
    ret2Len=(((plan.r2||0)+(layout==='u'?1:0))*1.2+stepSlots.right.length*.8).toFixed(1);
  let desc=layout==='straight'?`${plan.m} × TS01 main`:layout==='l'?`${plan.m+1} main bays (${plan.m} × TS01 + shared TS02) · ${plan.r+1} return bays (${plan.r} × TS01 + shared TS02)`: `${plan.m+2} main bays (${plan.m} × TS01 + 2 × TS02) · ${plan.r+1} left return bays · ${(plan.r2||0)+1} right return bays`;
  const thirdCount=plan.t?(layout==='straight'?plan.m:layout==='l'?plan.m+1:plan.m+2):0;
  const dimensionText=layout==='straight'
    ? `${mainLen} m overall width`
    : layout==='l'
      ? `${mainLen} m main × ${retLen} m return`
      : `${mainLen} m main × ${retLen} m left × ${ret2Len} m right`;
  let ts06Count=0;assembly.traverse(o=>{if(o.userData?.huxloSelectable&&o.userData.huxloBayType==='TS06')ts06Count++});
  let ts01StorageCount=0;assembly.traverse(o=>{if(o.userData?.huxloSelectable&&o.userData.huxloStorage)ts01StorageCount++});
  let ts09Count=0;assembly.traverse(o=>{if(o.userData?.huxloBarrier)ts09Count++});
  let ts10Count=0;assembly.traverse(o=>{if(o.userData?.huxloSideBarrier)ts10Count++});
  currentConfig={
    product:'Basecamp',
    layout:layout==='straight'?'Straight':layout==='l'?'L shape':'U shape',
    mainBays:plan.m+(layout==='straight'?0:layout==='l'?1:2),
    leftReturnBays:layout==='straight'?0:plan.r+1,
    rightReturnBays:layout==='u'?(plan.r2||0)+1:0,
    thirdTier:!!plan.t,
    pads:square?'Square':'Rectangle',
    finish:finish==='birch'?'Birch':'Oak',
    fabricRange:'Camira Era',
    fabrics:eraColours.map(code=>{const c=eraByCode(code);return {name:c.name,code:c.code,hex:c.hex}}),
    colourArrangement:eraColours.length>1?(colourArrangement==='unit'?'Alternate by unit':'Random by pad'):'Single colour',
    occupancy:plan.cap,
    dimensions:{main:mainLen,leftReturn:layout==='straight'?null:retLen,rightReturn:layout==='u'?ret2Len:null},
    modules:{
      TS01:plan.m+plan.r+(plan.r2||0)-ts06Count-ts01StorageCount,
      TS01_STORAGE:ts01StorageCount,
      TS06:ts06Count,
      TS14:stepSlots.main.length+stepSlots.left.length+stepSlots.right.length,
      TS04_800:plan.t?(stepSlots.main.length):0,
      TS09:ts09Count,
      TS10:ts10Count,
      TS02:layout==='straight'?0:layout==='l'?1:2,
      TS04:thirdCount
    },
    created:new Date().toISOString()
  };
  const commercialLines=commercialSchedule(currentConfig.modules);
  currentConfig.commercial={currency:'GBP',tax:'ex VAT',fabricRange:'Camira Era',lines:commercialLines,total:commercialLines.reduce((sum,l)=>sum+l.total,0),allMapped:commercialLines.every(l=>l.mapped)};
  const isMobileViewer=window.matchMedia('(max-width: 760px)').matches;
  viewerStats.innerHTML=isMobileViewer
    ? `<div class="stats-inline"><strong>${plan.cap} seats</strong><span class="stats-separator">|</span><span class="viewer-price">${money(currentConfig.commercial.total)} + VAT</span><button id="downloadsBtn" class="downloads-btn" type="button">Downloads</button></div>`
    : `<div class="stats-inline"><strong>${plan.cap} seats</strong><span class="stats-separator">|</span><span class="viewer-price">${money(currentConfig.commercial.total)} + VAT</span><button id="desktopDownloadPdfBtn" class="downloads-btn desktop-download-btn" type="button">PDF</button><button id="desktopDownloadModelBtn" class="downloads-btn desktop-download-btn" type="button">3D model</button></div>`;
  bindDownloadButtons();
  const downloadsBtn=document.getElementById('downloadsBtn');
  if(downloadsBtn)downloadsBtn.onclick=()=>{document.getElementById('downloadsModal').hidden=false;document.documentElement.classList.add('huxlo-modal-open')};
  const desktopPdf=document.getElementById('desktopDownloadPdfBtn');
  const desktopModel=document.getElementById('desktopDownloadModelBtn');
  if(desktopPdf)desktopPdf.onclick=()=>document.getElementById('downloadPdfBtn')?.click();
  if(desktopModel)desktopModel.onclick=()=>document.getElementById('downloadModelBtn')?.click();
  updateDimensions();
  rebuildWalls();
  if(doFit)fit();
  updateSelectionPanel();
  recordState();
}

function build(doFit=true){
  const keys=requiredModelKeys();
  const missing=keys.filter(k=>!modelGetters[k]?.());
  if(!missing.length){buildRequest++;return buildNow(doFit)}
  const request=++buildRequest;
  status.style.display='none';
  Promise.all(missing.map(ensureModel)).then(()=>{
    if(request!==buildRequest)return;
    status.style.display='none';
    buildNow(doFit);
  }).catch(e=>{
    console.error(e);
    if(request===buildRequest){status.style.display='block';status.textContent='Could not load the required 3D module.'}
  });
}

function safeName(){
  const d=new Date(), ds=d.toISOString().slice(0,10);
  return `Huxlo_Basecamp_${currentConfig?.layout?.replace(/\s+/g,'-')||'Design'}_${ds}`;
}
function downloadBlob(blob,name){
  const a=document.createElement('a');a.href=URL.createObjectURL(blob);a.download=name;document.body.appendChild(a);a.click();
  setTimeout(()=>{URL.revokeObjectURL(a.href);a.remove()},500);
}
function bindDownloadButtons(){
  const mb=document.getElementById('downloadModelBtn'), pb=document.getElementById('downloadPdfBtn');
  if(mb)mb.onclick=downloadGLB;if(pb)pb.onclick=downloadPDF;
}
async function downloadGLB(){
  if(!currentConfig)return;
  const exporter=new GLTFExporter();
  exporter.parse(assembly,result=>{
    const blob=new Blob([result],{type:'model/gltf-binary'});
    downloadBlob(blob,safeName()+'.glb');
  },err=>{console.error(err);alert('Could not export the 3D model.')},{binary:true,onlyVisible:true});
}

function frameCameraForView(view='iso'){
  const box=new THREE.Box3().setFromObject(assembly);
  const center=box.getCenter(new THREE.Vector3()), size=box.getSize(new THREE.Vector3());
  const max=Math.max(size.x,size.z,size.y*1.5,1);
  controls.target.copy(center);
  if(view==='top'){
    camera.position.set(center.x,center.y+max*2.55,center.z+.001);
    camera.up.set(0,0,-1);
  }else{
    camera.position.set(center.x+max*1.35,center.y+max*.92,center.z+max*1.35);
    camera.up.set(0,1,0);
  }
  camera.lookAt(center);camera.updateProjectionMatrix();controls.update();
}
function captureView(view){
  const oldPos=camera.position.clone(),oldQuat=camera.quaternion.clone(),oldUp=camera.up.clone(),oldTarget=controls.target.clone();
  const oldW=host.clientWidth,oldH=host.clientHeight,oldWallVisible=wallGroup.visible;
  wallGroup.visible=false;
  const w=1600,h=800;
  renderer.setSize(w,h,false);camera.aspect=w/h;camera.updateProjectionMatrix();
  frameCameraForView(view);renderer.render(scene,camera);
  const data=renderer.domElement.toDataURL('image/jpeg',.94);
  wallGroup.visible=oldWallVisible;
  renderer.setSize(oldW,oldH,false);camera.aspect=oldW/oldH;camera.position.copy(oldPos);camera.quaternion.copy(oldQuat);camera.up.copy(oldUp);controls.target.copy(oldTarget);camera.updateProjectionMatrix();controls.update();renderer.render(scene,camera);
  return data;
}
async function downloadPDF(){
  if(!currentConfig)return;
  if(!window.jspdf){alert('PDF library is still loading. Please try again in a moment.');return;}
  const {jsPDF}=window.jspdf, pdf=new jsPDF({orientation:'portrait',unit:'mm',format:'a4'});
  const cfg=currentConfig;
  const iso=captureView('iso'), top=captureView('top');
  pdf.setFont('helvetica','bold');pdf.setFontSize(20);pdf.text('Basecamp configuration',14,16);
  pdf.setFont('helvetica','normal');pdf.setFontSize(8.5);pdf.setTextColor(95);pdf.text(`Huxlo Workplace  ·  Created ${new Date(cfg.created).toLocaleDateString('en-GB')}`,14,22);
  pdf.setTextColor(20);
  // Both source images are exactly 2:1, so these 182 × 91 mm placements preserve aspect ratio.
  pdf.addImage(iso,'JPEG',14,28,182,91);
  pdf.setFontSize(7.5);pdf.setTextColor(100);pdf.text('Isometric view',14,123);
  pdf.addImage(top,'JPEG',14,128,182,91);
  pdf.setFontSize(7.5);pdf.setTextColor(100);pdf.text('Plan view',14,223);
  pdf.setDrawColor(215);pdf.line(14,228,196,228);
  let y=236;
  const heading=t=>{pdf.setFont('helvetica','bold');pdf.setFontSize(8.5);pdf.setTextColor(20);pdf.text(t,14,y);y+=5};
  const pair=(x1,a,b,x2,c,d)=>{pdf.setFont('helvetica','normal');pdf.setFontSize(7.5);pdf.setTextColor(105);pdf.text(a,x1,y);pdf.setTextColor(20);pdf.text(String(b),x1+28,y);if(c){pdf.setTextColor(105);pdf.text(c,x2,y);pdf.setTextColor(20);pdf.text(String(d),x2+28,y)}y+=5};
  heading('DESIGN');
  pair(14,'Layout',cfg.layout,108,'Occupancy',`${cfg.occupancy} seats`);
  const overall=cfg.overallDimensions?`${cfg.overallDimensions.x} × ${cfg.overallDimensions.y} m`:`${cfg.dimensions.main} m`;
  pair(14,'Overall size',overall,108,'Third tier',cfg.thirdTier?'Yes':'No');
  heading('PRODUCTS & FINISHES');
  pair(14,'Products',`TS01 × ${cfg.modules.TS01}  ·  TS01 STORAGE × ${cfg.modules.TS01_STORAGE||0}  ·  TS06 × ${cfg.modules.TS06||0}  ·  TS14 × ${cfg.modules.TS14||0}  ·  TS02 × ${cfg.modules.TS02}  ·  TS09 × ${cfg.modules.TS09||0}  ·  TS10 × ${cfg.modules.TS10||0}  ·  TS04 × ${cfg.modules.TS04}  ·  TS04-800 × ${cfg.modules.TS04_800||0}`,108,'Frame',cfg.finish);
  pair(14,'Pads',cfg.pads,108,'Fabric',cfg.fabricRange);
  const fabrics=cfg.fabrics.map(f=>`${f.name} (${f.code})`).join(', ');
  pair(14,'Colours',fabrics,108,'Arrangement',cfg.colourArrangement);
  pdf.setFontSize(6.5);pdf.setTextColor(110);
  pdf.text('Indicative configuration generated by the Huxlo Basecamp configurator. Final specification subject to Huxlo confirmation.',14,290);
  pdf.save(safeName()+'_Specification.pdf');
}
loadLiveShopifyPricing();
ensureModel('TS01').then(()=>{status.style.display='none';build(true);setTimeout(()=>{loadDesignFromURL()},0);preloadRemainingModels()}).catch(e=>{console.error(e);status.textContent='Could not load the Basecamp 3D model.'});
function updateEraDone(){
  const n=eraColours.length;
  eraDone.textContent=`${n} ${n===1?'colour':'colours'} selected - Done`;
}
function renderSelectedEra(){
  updateEraDone();
  selectedEraColours.innerHTML=eraColours.map(code=>{
    const c=eraByCode(code);
    return `<div class="colour-chip"><span class="colour-dot" style="background:${c.hex}"></span><span>${c.name}<br><span style="color:#777">${c.code}</span></span></div>`;
  }).join('');
  arrangementGroup.style.display=eraColours.length>1?'block':'none';
}
function renderEraGrid(filter=''){
  const q=filter.trim().toLowerCase();
  eraGrid.innerHTML='';
  ERA_COLOURS.filter(c=>!q || c.name.toLowerCase().includes(q) || c.code.toLowerCase().includes(q)).forEach(c=>{
    const selected=eraColours.includes(c.code);
    const disabled=!selected && eraColours.length>=3;
    const b=document.createElement('button');
    b.type='button';b.className='era-swatch'+(selected?' selected':'')+(disabled?' disabled':'');
    b.disabled=disabled;
    b.innerHTML=`<div class="era-colour" style="background:${c.hex}"></div><div class="era-name">${c.name}</div><div class="era-code">${c.code}</div>`;
    b.onclick=()=>{
      if(selected){ if(eraColours.length>1) eraColours=eraColours.filter(x=>x!==c.code); }
      else if(eraColours.length<3) eraColours.push(c.code);
      renderEraGrid(eraSearch.value);renderSelectedEra();build(false);
    };
    eraGrid.appendChild(b);
  });
}
chooseEraBtn.onclick=()=>{
  const lm=document.getElementById('layoutModal');
  if(window.matchMedia('(max-width: 760px)').matches&&lm)lm.hidden=true;
  eraModal.hidden=false;
  if(window.matchMedia('(max-width: 760px)').matches)document.documentElement.classList.add('huxlo-modal-open');
  renderEraGrid(eraSearch.value);eraSearch.focus();
};
eraDone.onclick=()=>{eraModal.hidden=true;if(window.matchMedia('(max-width: 760px)').matches)document.documentElement.classList.remove('huxlo-modal-open')};
eraBackdrop.onclick=()=>{eraModal.hidden=true;if(window.matchMedia('(max-width: 760px)').matches)document.documentElement.classList.remove('huxlo-modal-open')};
eraSearch.oninput=()=>renderEraGrid(eraSearch.value);
alternateUnitBtn.onclick=()=>{colourArrangement='unit';alternateUnitBtn.classList.add('active');randomPadBtn.classList.remove('active');build(false)};
randomPadBtn.onclick=()=>{colourArrangement='pad';randomPadBtn.classList.add('active');alternateUnitBtn.classList.remove('active');build(false)};
renderSelectedEra();
function updateModeUI(){
  // The main interface is always Design Control. Wizard is a one-shot design generator.
  designControls.style.display='block';
  designReturnGroup.style.display=layout!=='straight'?'block':'none';
  designReturn2Group.style.display=layout==='u'?'block':'none';
}
function setWizardLayout(next){
  wizardLayout=next;
  wStraightBtn.classList.toggle('active',next==='straight');
  wLBtn.classList.toggle('active',next==='l');
  wUBtn.classList.toggle('active',next==='u');
  returnGroup.style.display=next!=='straight'?'block':'none';
  return2Group.style.display=next==='u'?'block':'none';
}
let wizardLayout=layout;
let wizardAllowThird=true;
wizardBtn.onclick=()=>{wizardLayout=layout;setWizardLayout(wizardLayout);thirdMode=wizardAllowThird?'auto':'none';wizardThirdYes.classList.toggle('active',wizardAllowThird);wizardThirdNo.classList.toggle('active',!wizardAllowThird);wizardModal.hidden=false};
wizardBackdrop.onclick=wizardCancel.onclick=()=>{wizardModal.hidden=true};
wStraightBtn.onclick=()=>setWizardLayout('straight');
wLBtn.onclick=()=>setWizardLayout('l');
wUBtn.onclick=()=>setWizardLayout('u');
wizardThirdYes.onclick=()=>{wizardAllowThird=true;thirdMode='auto';wizardThirdYes.classList.add('active');wizardThirdNo.classList.remove('active')};
wizardThirdNo.onclick=()=>{wizardAllowThird=false;thirdMode='none';wizardThirdNo.classList.add('active');wizardThirdYes.classList.remove('active')};
wizardCreate.onclick=()=>{
  layout=wizardLayout;
  thirdMode=wizardAllowThird?'auto':'none';
  configMode='wizard';
  const plan=solveLayout();
  if(!plan.fits){
    capacityMessage.innerHTML=`Maximum capacity in the available space is <b>${plan.cap} seats</b>. Increase the available space or reduce the required occupancy.`;
    capacityMessage.style.color='#9b3b31';
    return;
  }
  // Convert the generated plan into editable Design Control values.
  designMain=plan.m+(layout==='straight'?0:layout==='l'?1:2);
  designReturn=layout==='straight'?1:plan.r+1;
  designReturn2=layout==='u'?(plan.r2||0)+1:1;
  designThird=plan.t;
  document.getElementById('designMain').min=layout==='u'?3:1;
  document.getElementById('designMain').value=designMain;designMainValue.textContent=designMain;
  document.getElementById('designReturn').value=designReturn;designReturnValue.textContent=designReturn;
  document.getElementById('designReturn2').value=designReturn2;designReturn2Value.textContent=designReturn2;
  designThirdToggle.checked=!!designThird;
  straightBtn.classList.toggle('active',layout==='straight');lBtn.classList.toggle('active',layout==='l');uBtn.classList.toggle('active',layout==='u');
  configMode='design';
  capacityMessage.innerHTML='';
  wizardModal.hidden=true;
  updateModeUI();
  build(true);
};
document.getElementById('designMain').oninput=e=>{designMain=+e.target.value;designMainValue.textContent=designMain;build(true)};
document.getElementById('designReturn').oninput=e=>{designReturn=+e.target.value;designReturnValue.textContent=designReturn;build(true)};
document.getElementById('designReturn2').oninput=e=>{designReturn2=+e.target.value;designReturn2Value.textContent=designReturn2;build(true)};
designThirdToggle.onchange=()=>{designThird=designThirdToggle.checked;build(true)};
straightBtn.onclick=()=>{layout='straight';document.getElementById('designMain').min=1;straightBtn.classList.add('active');lBtn.classList.remove('active');uBtn.classList.remove('active');updateModeUI();build(true)};
lBtn.onclick=()=>{layout='l';document.getElementById('designMain').min=1;lBtn.classList.add('active');straightBtn.classList.remove('active');uBtn.classList.remove('active');updateModeUI();build(true)};
uBtn.onclick=()=>{layout='u';uBtn.classList.add('active');straightBtn.classList.remove('active');lBtn.classList.remove('active');document.getElementById('designMain').min=3;if(designMain<3){designMain=3;designMainValue.textContent='3';document.getElementById('designMain').value=3;}updateModeUI();build(true)};
document.getElementById('mainRun').oninput=e=>{mainBays=+e.target.value;mainRunValue.textContent=mainBays.toFixed(1)};
document.getElementById('returnRun').oninput=e=>{returnBays=+e.target.value;returnRunValue.textContent=returnBays.toFixed(1)};
document.getElementById('returnRun2').oninput=e=>{returnBays2=+e.target.value;returnRun2Value.textContent=returnBays2.toFixed(1)};
document.getElementById('seatTarget').oninput=e=>{seatTarget=+e.target.value;seatTargetValue.textContent=seatTarget};
squareBtn.onclick=()=>{square=true;squareBtn.classList.add('active');rectangleBtn.classList.remove('active');build(false)};
rectangleBtn.onclick=()=>{square=false;rectangleBtn.classList.add('active');squareBtn.classList.remove('active');build(false)};
birchBtn.onclick=()=>{finish='birch';birchBtn.classList.add('active');oakBtn.classList.remove('active');build(false)};
oakBtn.onclick=()=>{finish='oak';oakBtn.classList.add('active');birchBtn.classList.remove('active');build(false)};


const raycaster=new THREE.Raycaster(), pointer=new THREE.Vector2();
function hitBayAtEvent(e){
  const r=renderer.domElement.getBoundingClientRect();
  pointer.x=((e.clientX-r.left)/r.width)*2-1;pointer.y=-((e.clientY-r.top)/r.height)*2+1;
  raycaster.setFromCamera(pointer,camera);
  const controls=[];interactionGroup.traverse(o=>{if(o.userData?.huxloInsert||o.userData?.huxloMove||o.userData?.huxloDelete)controls.push(o)});
  const ih=raycaster.intersectObjects(controls,false);
  if(ih.length){
    const o=ih[0].object;
    if(o.userData.huxloMove)return {kind:'move',run:o.userData.run,slot:o.userData.slot,dir:o.userData.dir,sprite:o};
    if(o.userData.huxloDelete)return {kind:'delete',run:o.userData.run,slot:o.userData.slot,sprite:o};
    return {kind:'insert',run:o.userData.run,slot:o.userData.slot,key:null,sprite:o};
  }
  const boxes=[];assembly.traverse(o=>{if(o.userData?.huxloHitBox)boxes.push(o)});
  const hits=raycaster.intersectObjects(boxes,false);
  if(!hits.length)return null;
  let o=hits[0].object,key=o.userData.huxloBayKey||null;
  // TS14 hit boxes are children of the TS14 root; use the root's canonical key.
  let parent=o.parent;while(parent&&parent!==assembly){if(parent.userData?.huxloBayType==='TS14'){key=parent.userData.huxloBayKey;break}parent=parent.parent}
  return {kind:'module',key};
}
renderer.domElement.addEventListener('pointermove',e=>{
  const hit=hitBayAtEvent(e),key=hit?.kind==='module'?hit.key:null;
  if(key!==hoveredBayKey){hoveredBayKey=key;applyBayVisuals()}
  interactionGroup.traverse(o=>{if(o.isSprite)o.userData.huxloHot=(o===hit?.sprite)});
  updateInteractionSprites();
  renderer.domElement.style.cursor=hit?'pointer':''
});
renderer.domElement.addEventListener('pointerleave',()=>{
  hoveredBayKey=null;applyBayVisuals();interactionGroup.traverse(o=>{if(o.isSprite)o.userData.huxloHot=false});updateInteractionSprites();renderer.domElement.style.cursor='';
});
renderer.domElement.addEventListener('pointerdown',e=>{
  if(e.button!==0)return;
  const hit=hitBayAtEvent(e);
  if(hit?.kind==='insert'){addStep(hit.run,hit.slot);hoveredBayKey=null;updateSelectionPanel();applyBayVisuals();}
  else if(hit?.kind==='move'){moveStep(hit.run,hit.slot,hit.dir);hoveredBayKey=null;updateSelectionPanel();applyBayVisuals();}
  else if(hit?.kind==='delete'){removeStep(hit.run,hit.slot);hoveredBayKey=null;updateSelectionPanel();applyBayVisuals();}
  else if(hit?.kind==='module'){
    selectedBayKey=hit.key;hoveredBayKey=hit.key;
    updateSelectionPanel();applyBayVisuals();
    if(mobileMq.matches){document.getElementById('selectionModal').hidden=false;document.documentElement.classList.add('huxlo-modal-open');}
  }else{
    selectedBayKey=null;hoveredBayKey=null;updateSelectionPanel();applyBayVisuals();
  }
});
addStairsBefore.onclick=()=>{const run=addStairsBefore.dataset.run,slot=+addStairsBefore.dataset.slot;if(run&&!hasStep(run,slot))addStep(run,slot)};
addStairsAfter.onclick=()=>{const run=addStairsAfter.dataset.run,slot=+addStairsAfter.dataset.slot;if(run&&!hasStep(run,slot))addStep(run,slot)};
selectTS01.onclick=()=>setSelectedBayType('TS01');
selectTS06.onclick=()=>setSelectedBayType('TS06');
storageCheckbox.onchange=()=>{
  if(!selectedBayKey)return;
  let target=null;assembly.traverse(o=>{if(o.userData?.huxloSelectable&&o.userData.huxloBayKey===selectedBayKey)target=o});
  if(!target||target.userData.huxloBayType!=='TS01')return;
  if(storageCheckbox.checked)storageBays.add(selectedBayKey);else storageBays.delete(selectedBayKey);
  build(false);updateSelectionPanel();applyBayVisuals();
};



barrierCheckbox.onchange=()=>{if(selectedBayKey)setBarrier(selectedBayKey,barrierCheckbox.checked)};
sideBarrierCheckbox.onchange=()=>{if(selectedBayKey)setSideBarrier(selectedBayKey,sideBarrierCheckbox.checked)};
barriersAddAll.onclick=()=>{allBarrierKeys().forEach(k=>barrierBays.add(k));if(layout==='l'||layout==='u')sideBarrierBays.add('corner:left');if(layout==='u')sideBarrierBays.add('corner:right');build(false)};
barriersRemoveAll.onclick=()=>{barrierBays.clear();sideBarrierBays.clear();build(false)};
wallsCheckbox.onchange=()=>{wallsVisible=wallsCheckbox.checked;wallsToggle.title=wallsVisible?'Hide surrounding walls':'Show surrounding walls';if(wallsVisible)rebuildWalls();else wallGroup.visible=false};
stepLeft.onclick=()=>{const [,r,sl]=selectedBayKey.split(':');moveStep(r,+sl,-1)};
stepRight.onclick=()=>{const [,r,sl]=selectedBayKey.split(':');moveStep(r,+sl,1)};
stepRemove.onclick=()=>{const [,r,sl]=selectedBayKey.split(':');removeStep(r,+sl)};

priceClose.onclick=()=>priceModal.hidden=true;priceBackdrop.onclick=()=>priceModal.hidden=true;
undoBtn.onclick=undoDesign;redoBtn.onclick=redoDesign;updateHistoryUI();
function closeFlow(id){document.getElementById(id).hidden=true}document.querySelectorAll('[data-close]').forEach(b=>b.onclick=()=>closeFlow(b.dataset.close));saveCancel.onclick=()=>closeFlow('saveModal');quoteCancel.onclick=()=>closeFlow('quoteModal');
saveDesignBtn.onclick=()=>{saveResult.hidden=true;saveConfirm.disabled=false;saveConfirm.textContent='Save & email design';saveModal.hidden=false};requestQuoteBtn.onclick=()=>{quoteResult.hidden=true;quoteModal.hidden=false};addToCartBtn.onclick=addConfigurationToCart;
saveConfirm.onclick=async()=>{const email=saveEmail.value.trim();if(!email){saveEmail.focus();return}let sent=false;saveConfirm.disabled=true;saveConfirm.textContent='Saving…';try{const saved=await saveBackendDesign({email,kind:'saved-design'});const emailResponse=await fetch(`${DESIGN_API_URL}/${encodeURIComponent(saved.id)}/email`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email})});const emailData=await emailResponse.json().catch(()=>({}));if(!emailResponse.ok||!emailData.ok)throw new Error(emailData.error||`Email failed (${emailResponse.status})`);sent=true;saveResult.hidden=false;saveResult.innerHTML='<b>✓ Design saved and emailed.</b><br>Design ID: '+saved.id+'<br><br><button id="copySavedDesignLink" type="button">Copy link</button>';const copyBtn=document.getElementById('copySavedDesignLink');copyBtn.onclick=async()=>{try{await navigator.clipboard.writeText(saved.link);copyBtn.textContent='✓ Link copied'}catch{copyBtn.textContent=saved.link}}}catch(e){saveResult.hidden=false;saveResult.textContent='Could not save and email design: '+e.message}finally{saveConfirm.disabled=sent;saveConfirm.textContent='Save & email design'}};
quoteConfirm.onclick=async()=>{const email=quoteEmail.value.trim(),name=quoteName.value.trim();if(!name){quoteName.focus();return}if(!email){quoteEmail.focus();return}quoteConfirm.disabled=true;quoteConfirm.textContent='Saving…';try{const saved=await saveBackendDesign({kind:'quote',name,email,company:quoteCompany.value.trim(),project:quoteProject.value.trim(),postcode:quotePostcode.value.trim(),notes:quoteNotes.value.trim()});quoteResult.hidden=false;quoteResult.innerHTML='<b>Quote design saved.</b><br>Design ID: '+saved.id+'<br><br><a href="'+saved.link+'" target="_blank" rel="noopener">View saved design</a><br><br><small>HubSpot enquiry submission can be connected as the next CRM step.</small>'}catch(e){quoteResult.hidden=false;quoteResult.textContent='Could not save quote design: '+e.message}finally{quoteConfirm.disabled=false;quoteConfirm.textContent='Save quote request'}};
updateModeUI();
function resize(){const w=host.clientWidth,h=host.clientHeight;renderer.setSize(w,h,false);camera.aspect=w/h;camera.updateProjectionMatrix()}addEventListener('resize',resize);resize();renderer.setAnimationLoop(()=>{controls.update();renderer.render(scene,camera)});


// v41 — size the desktop Designer to the visible viewport below the Shopify header.
function syncDesktopViewportHeight(){
  if(window.matchMedia('(max-width: 760px)').matches)return;
  const root=document.getElementById('huxlo-basecamp-configurator');
  if(!root||IS_EMBEDDED)return;
  const top=Math.max(0,root.getBoundingClientRect().top);
  root.style.height=`${Math.max(320,window.innerHeight-top)}px`;
}
window.addEventListener('resize',syncDesktopViewportHeight);
requestAnimationFrame(syncDesktopViewportHeight);

// v37 — modal-first mobile UI. Desktop layout/behaviour is preserved.
const mobileMq=window.matchMedia('(max-width: 760px)');
const configuratorApp=document.querySelector('#huxlo-basecamp-configurator .app');
const configuratorPanel=document.querySelector('#huxlo-basecamp-configurator .panel');
const panelHomeNext=configuratorPanel.nextSibling;
const mobileLayoutSlot=document.getElementById('mobileLayoutSlot');
const mobileSelectionSlot=document.getElementById('mobileSelectionSlot');
const desktopSelectionHome=document.getElementById('viewer');
const desktopStats=document.getElementById('viewerStats');
const selectionPanelEl=document.getElementById('selectionPanel');
const layoutModal=document.getElementById('layoutModal');
const selectionModal=document.getElementById('selectionModal');
const downloadsModal=document.getElementById('downloadsModal');
const mobileLayoutBtn=document.getElementById('mobileLayoutBtn');

function closeCompactModal(id){const el=document.getElementById(id);if(el)el.hidden=true;if(mobileMq.matches)document.documentElement.classList.remove('huxlo-modal-open')}
document.querySelectorAll('[data-compact-close]').forEach(el=>el.addEventListener('click',()=>closeCompactModal(el.dataset.compactClose)));
mobileLayoutBtn.addEventListener('click',()=>{layoutModal.hidden=false;document.documentElement.classList.add('huxlo-modal-open')});

// A module choice is a quick action on mobile: apply it, then return to the model.
selectionModal.addEventListener('click',e=>{
  if(!mobileMq.matches)return;
  if(e.target.closest('button'))requestAnimationFrame(()=>{selectionModal.hidden=true;document.documentElement.classList.remove('huxlo-modal-open')});
});
selectionModal.addEventListener('change',()=>{if(mobileMq.matches)requestAnimationFrame(()=>{selectionModal.hidden=true;document.documentElement.classList.remove('huxlo-modal-open')})});

function applyResponsiveShell(){
  if(mobileMq.matches){
    if(configuratorPanel.parentElement!==mobileLayoutSlot)mobileLayoutSlot.appendChild(configuratorPanel);
    if(selectionPanelEl.parentElement!==mobileSelectionSlot)mobileSelectionSlot.appendChild(selectionPanelEl);
  }else{
    layoutModal.hidden=true;selectionModal.hidden=true;downloadsModal.hidden=true;document.documentElement.classList.remove('huxlo-modal-open');
    if(configuratorPanel.parentElement!==configuratorApp)configuratorApp.insertBefore(configuratorPanel,panelHomeNext);
    if(selectionPanelEl.parentElement!==desktopSelectionHome)desktopSelectionHome.insertBefore(selectionPanelEl,desktopStats);
  }
  requestAnimationFrame(resize);
}
mobileMq.addEventListener?.('change',applyResponsiveShell);
applyResponsiveShell();

// v40 — keep the fixed mobile Designer below the Shopify header rather than covering it.
function syncMobileHeaderOffset(){
  if(!mobileMq.matches){
    document.documentElement.style.removeProperty('--huxlo-mobile-header-bottom');
    return;
  }
  const candidates=[
    document.querySelector('.shopify-section-group-header-group'),
    document.querySelector('#shopify-section-header'),
    document.querySelector('header')
  ].filter(Boolean);
  let bottom=0;
  for(const el of candidates){
    const r=el.getBoundingClientRect();
    if(r.height>0 && r.bottom>0 && r.bottom<300) bottom=Math.max(bottom,r.bottom);
  }
  if(!bottom) bottom=70;
  document.documentElement.style.setProperty('--huxlo-mobile-header-bottom',Math.round(bottom)+'px');
  requestAnimationFrame(resize);
}
window.addEventListener('resize',syncMobileHeaderOffset);
window.addEventListener('orientationchange',()=>setTimeout(syncMobileHeaderOffset,100));
mobileMq.addEventListener?.('change',syncMobileHeaderOffset);
syncMobileHeaderOffset();

// v46 — embedded "Full Screen (excluding header)" section height.
function syncEmbeddedViewportHeight(){
  if(!IS_EMBEDDED || !CONFIGURATOR_ROOT?.classList.contains('huxlo-embed-viewport')) return;
  const candidates=[
    document.querySelector('.shopify-section-group-header-group'),
    document.querySelector('#shopify-section-header'),
    document.querySelector('header')
  ].filter(Boolean);
  let headerHeight=0;
  for(const el of candidates){
    const r=el.getBoundingClientRect();
    if(r.height>0 && r.height<300) headerHeight=Math.max(headerHeight,r.height);
  }
  document.documentElement.style.setProperty('--huxlo-embed-header-height',Math.round(headerHeight)+'px');
  requestAnimationFrame(resize);
}
window.addEventListener('resize',syncEmbeddedViewportHeight);
window.addEventListener('orientationchange',()=>setTimeout(syncEmbeddedViewportHeight,100));
requestAnimationFrame(syncEmbeddedViewportHeight);

// v45 — embedded section full-screen control.
const embedFullscreenBtn=document.getElementById('embedFullscreenBtn');
if(embedFullscreenBtn){
  embedFullscreenBtn.addEventListener('click',async()=>{
    try{
      if(document.fullscreenElement===CONFIGURATOR_ROOT) await document.exitFullscreen();
      else await CONFIGURATOR_ROOT.requestFullscreen();
    }catch(e){console.warn('Full screen unavailable',e)}
  });
  document.addEventListener('fullscreenchange',()=>{
    const active=document.fullscreenElement===CONFIGURATOR_ROOT;
    CONFIGURATOR_ROOT?.classList.toggle('is-fullscreen',active);
    embedFullscreenBtn.textContent=active?'Exit full screen':'Full screen';
    requestAnimationFrame(resize);
  });
}

// v42 — desktop height is based on the Designer's real top edge.
// The Shopify header remains untouched and visible in normal document flow.
function syncDesktopConfiguratorTop(){
  if(mobileMq.matches){
    document.documentElement.style.removeProperty('--huxlo-desktop-configurator-top');
    return;
  }
  const root=document.getElementById('huxlo-basecamp-configurator');
  if(!root||IS_EMBEDDED)return;
  const top=Math.max(0,root.getBoundingClientRect().top);
  document.documentElement.style.setProperty('--huxlo-desktop-configurator-top',Math.round(top)+'px');
  requestAnimationFrame(resize);
}
window.addEventListener('resize',syncDesktopConfiguratorTop);
mobileMq.addEventListener?.('change',syncDesktopConfiguratorTop);
requestAnimationFrame(syncDesktopConfiguratorTop);
